import type { FlashSaleRotation } from '../../utils/campaign/flashSaleRotation';

interface GguFlashSaleRotation extends FlashSaleRotation {
  collectionSlug: string;
}

/**
 * GGU II (Great Glow Up Phase 2) Flash Sale rotation schedule
 * All times are in SGT (Asia/Singapore timezone)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 *
 * Seven collections rotate daily, each live for 24 hours (3PM SGT -> 3PM SGT).
 */
export const GGU_FLASH_SALE_ROTATIONS: GguFlashSaleRotation[] = [
  {
    startDate: '2026-06-24 15:00:00',
    endDate: '2026-06-25 15:00:00',
    collectionName: 'GGU Flash Sale 1',
    collectionSlug: 'ggu-flash-sale-1',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  {
    startDate: '2026-06-25 15:00:00',
    endDate: '2026-06-26 15:00:00',
    collectionName: 'GGU Flash Sale 2',
    collectionSlug: 'ggu-flash-sale-2',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  {
    startDate: '2026-06-26 15:00:00',
    endDate: '2026-06-27 15:00:00',
    collectionName: 'GGU Flash Sale 3',
    collectionSlug: 'ggu-flash-sale-3',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  {
    startDate: '2026-06-27 15:00:00',
    endDate: '2026-06-28 15:00:00',
    collectionName: 'GGU Flash Sale 4',
    collectionSlug: 'ggu-flash-sale-4',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  {
    startDate: '2026-06-28 15:00:00',
    endDate: '2026-06-29 15:00:00',
    collectionName: 'GGU Flash Sale 5',
    collectionSlug: 'ggu-flash-sale-5',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  {
    startDate: '2026-06-29 15:00:00',
    endDate: '2026-06-30 15:00:00',
    collectionName: 'GGU Flash Sale 6',
    collectionSlug: 'ggu-flash-sale-6',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
  {
    startDate: '2026-06-30 15:00:00',
    endDate: '2026-07-01 15:00:00',
    collectionName: 'GGU Flash Sale 7',
    collectionSlug: 'ggu-flash-sale-7',
    campaignUrl: '/campaign/great-glow-up-2/',
  },
];

export const GGU_FLASH_SALE_TIMEZONE = 'Asia/Singapore';

export const GGU_SALE_CAMPAIGN_CONFIG = {
  bannerTitle: 'New deals every 24 hours!',
  bannerSubtitle: 'Grab your favorites fast.',
  textBannerCopy: 'Up to 70% off across the selection',
} as const;
